import { useState } from "react";
import { Text, Heading, Link, Picker, PickerItem } from "@react-spectrum/s2";
import LinkOutIcon from "icon:@app/assets/S2_LinkOutSize100.svg";
import { useVideoTemplate } from "@app/hooks/videos";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };
import { headingStyle } from "../style" with { type: "macro" };

export const VerticalSelect = ({
  templateId,
  verticals,
  selectedVertical,
  setSelectedVertical,
}) => {
  const template = useVideoTemplate(templateId);

  return (
    <div className={style({ width: 360, maxWidth: "full" })}>
      <Heading styles={style(headingStyle())}>
        <Text>Vertical preset</Text>
      </Heading>

      <p
        className={style({
          font: "body-sm",
          marginTop: 0,
          marginBottom: 24,
        })}
      >
        Pick one vertical to shape your story&apos;s perspective.
      </p>

      <Picker
        label="Select vertical"
        description={
          !!template?.data?.verticalsPreviewUrl && (
            <>
              <Text slot="description">See how each vertical looks</Text>
              <Link
                href={template.data.verticalsPreviewUrl}
                target="_blank"
                isStandalone
                staticColor="auto"
                slot="contextualHelp"
              >
                <Text slot="description">Preview</Text>
                <LinkOutIcon styles={style({ size: 8, marginStart: 8 })} />
              </Link>
            </>
          )
        }
        items={verticals}
        selectionMode="single"
        value={selectedVertical?.key}
        onChange={setSelectedVertical}
      >
        {(item) => (
          <PickerItem
            id={item.key}
            textValue={item.name}
            isDisabled={item.isDisabled}
          >
            <Text slot="label">{item.name}</Text>
          </PickerItem>
        )}
      </Picker>
    </div>
  );
};
